module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/team-3-3a0e6731556ca7b8a273b883d628f3b5.jpg";